import React from 'react';
import { useTranslation } from 'react-i18next';
import CancelModal from 'apps/Orders/FieldList/FullProductReport/common/CancelModal';

import showToast from 'actions/toastActions';
import { DispatchType } from 'store/dispatch/types';
import { putSamplePlan } from 'store/samplePlans/requests';
import { SamplePlanType } from 'store/samplePlans/types';

type MarkNotReadyPropsType = {
  samplePlan: SamplePlanType | DispatchType;
  onSubmit: VoidFunction;
  onClose: VoidFunction;
  opened: boolean;
};

export const MarkNotReady = ({ samplePlan, onSubmit, onClose, opened }: MarkNotReadyPropsType) => {
  const { t } = useTranslation();

  const markNotReady = async () => {
    try {
      await putSamplePlan({ ready_to_sample: false }, samplePlan.id);
      showToast(t('markNotReadySuccess'));
      onSubmit();
    } catch (e) {
      onClose();
      showToast(t('markNotReadyFail'), 'error', 7000);
    }
  };

  return (
    <CancelModal
      cancelTitle={t('markNotReady')}
      cancelText={t('sureMarkNotReady')}
      cancel={markNotReady}
      isFetching={false}
      hideModal={onClose}
      opened={opened}
    />
  );
};
